import React, { Component } from 'react';
import { Row, Col, Form, Input, Select } from 'antd';
import { UserPhoto } from "../../common/userPhoto/userPhoto";
import displayServerErrors from '../../../utilities/form/display_server_errors';

const FormItem = Form.Item;
const { TextArea } = Input;

export default class CreateEvangelistForm extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  async submitData() {
    try {
      this.setState({ loading: true });
      const {data} = await this.props.mutate(this.props.mutationParams());
      this.props.redirectTo(data);
    } catch(response) {
      displayServerErrors(this.props.form, response);
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit(event) {
    event.preventDefault();

    this.props.form.validateFields((error, _values) => {
      if (!error) {
        this.submitData();
      }
    });
  }

  onPhotoLoad = (photoDataUri) => {
    this.props.form.setFieldsValue({ photo_data_uri: photoDataUri });
  };

  onPhotoRemove = () => {
    this.props.form.setFieldsValue({ remove_photo: true, photo_data_uri: '' });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { evangelist } = this.props;

    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <Form onSubmit={this.onSubmit.bind(this)} className="login-form">
            <h1 className="login-form__header">{evangelist ? "Edit Evangelist" : "Invite an Evangelist"}</h1>
            <Row>
              <Col lg={7} xl={5} xxl={3} xs={24} className="profile-page__sider">
                <div className="profile-page__photo-block">
                  <FormItem className="profile-form__item--nomargin">
                    {getFieldDecorator('photo_data_uri')(
                      <UserPhoto photoURL={this.props.evangelist && this.props.evangelist.photo.small} onPhotoLoad={this.onPhotoLoad} onPhotoRemove={this.onPhotoRemove} />
                    )}
                  </FormItem>
                  <FormItem className="profile-form__item--hidden">
                    {getFieldDecorator('remove_photo', {
                      initialValue: false
                    })(
                      <Input type="boolean" />
                    )}
                  </FormItem>
                </div>
              </Col>
              <Col xs={{span: 24}} lg={{offset: 1, span: 16}}>
                <FormItem label="Email (app username)">
                  {getFieldDecorator('email', {
                    rules: [
                      { required: true, message: 'Please specify Evangelist email' },
                      { type: "email", message: 'Evangelist email is not valid' }
                    ],
                    initialValue: evangelist ? evangelist.email : null
                  })(
                    <Input placeholder="Evangelist email" disabled={evangelist && evangelist.passwordCreated} />
                  )}
                </FormItem>
                <FormItem label="Name">
                  {getFieldDecorator('name', {
                    rules: [
                      { required: true, message: 'Please specify Evangelist name' }
                    ],
                    initialValue: evangelist ? evangelist.name : null
                  })(
                    <Input placeholder="Evangelist name" />
                  )}
                </FormItem>

                <FormItem>
                  { this.props.formControls(this.state.loading) }
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/createEvangelistForm.js